import { render, staticRenderFns } from "./MekariSidebarChild.vue?vue&type=template&id=6b29ca1d&"
import script from "./MekariSidebarChild.vue?vue&type=script&lang=js&"
export * from "./MekariSidebarChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports